import { type ProductConfigurationMap } from '../../types';
import { isFedRamp } from '@atlassian/atl-context';
import { formatLabel } from '../providers/product-configuration-provider';
import messages from './messages';

export function buildGoalsProduct(
	productConfigurationMap: ProductConfigurationMap,
	isGoalsAsAppEnabled?: boolean,
): ProductConfigurationMap {
	if (isFedRamp() || !isGoalsAsAppEnabled) {
		return productConfigurationMap;
	}

	return {
		...productConfigurationMap,
		GOALS: {
			label: formatLabel(messages.goals),
			iconKey: 'goals',
			key: 'goals',
			ordinal: 18,
		},
	};
}
